var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMassiveHelmet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4518_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 8.77812C15.1111 5.99156 13.3936 3.60938 11.2333 2.60938L9.77777 5.44375V1.55562C9.77777 1.24719 9.55833 1 9.28333 1H6.71666C6.44166 1 6.22222 1.24719 6.22222 1.55562V5.44312L4.76666 2.61031C2.60639 3.60938 0.888885 5.99062 0.888885 8.77812L0.888607 11H15.1108L15.1111 8.77812ZM15.9639 12.3031C15.8944 12.1188 15.7333 12 15.5556 12H0.444441C0.357696 12.0001 0.272874 12.0288 0.200387 12.0824C0.127899 12.136 0.0709 12.2122 0.0363849 12.3018C-0.0339207 12.4853 -0.000948437 12.6983 0.12144 12.8436C0.195302 12.9312 2.00055 15 7.975 15C13.9494 15 15.7556 12.9316 15.8528 12.8438C16 12.6969 16.0333 12.4844 15.9639 12.3031Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4518_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMassiveHelmet);
export default __webpack_public_path__ + "static/media/icon--massive-helmet.3a64344a175bd1ec63a5b3afc589bd3e.svg";
export { ForwardRef as ReactComponent };